import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { AppDownloadConfigService } from "@obg/ngx.common";
import { OperatingSystemService, PlatformName } from "@obg/ngx.core";

@Component({
	selector: "obg-m-wagering-block-dialog",
	styleUrls: ["./wagering-block-dialog.container.scss"],
	templateUrl: "./wagering-block-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class WageringBlockDialogContainer {
	@HostBinding("class.wagering-block-dialog-container") hostCssClass = true;

	readonly isIOS = this.operatingSystemService.getOperatingSystem() === PlatformName.IOS;
	readonly isAndroid = this.operatingSystemService.getOperatingSystem() === PlatformName.Android;

	readonly appStoreUrl = this.appDownloadConfig.getAppStoreUrl();
	readonly androidAppUrl = this.appDownloadConfig.getAndroidAppUrl();

	constructor(
		private appDownloadConfig: AppDownloadConfigService,
		private operatingSystemService: OperatingSystemService
	) {}
}
